/*
	ボタンボックス
*/

import React, { memo } from 'react';
import classes from './payment-button-box.module.scss';

import { PrimaryButton } from 'components/atoms/primary-button/PrimaryButton';

type Props = {
	activeMessage: string;
	passiveMessage: string;
	activeEvent: () => void;
	passiveEvent: () => void;
	activeButtonDisabled?: boolean;
};
export const PaymentButtonBox = memo((props: Props) => {
	const { activeMessage, passiveMessage, activeEvent, passiveEvent, activeButtonDisabled = false } = props;

	return (
		<div className="btn-box">
			<div className="btn wh">
				<PrimaryButton message={passiveMessage} onClickEvent={passiveEvent} />
			</div>
			<div className="btn gr">
				<PrimaryButton
					message={activeMessage}
					onClickEvent={activeEvent}
					className={activeButtonDisabled ? classes.disabled : ''}
					disabled={activeButtonDisabled}
				/>
			</div>
		</div>
	);
});
